import { Filter } from '@anytag/shared-molecules';
import { FilterAction } from '@anytag/shared-types';
import { Template, TemplateProps } from './Template';
import { MarketplacePostsFilterFormValues } from './schemaTypes';

export type MarketplacePostsFilterProps = FilterAction<MarketplacePostsFilterFormValues> &
  Omit<TemplateProps, 'onSubmit'>;

export const MarketplacePostsFilter = ({ filter, setFilter, ...templateProps }: MarketplacePostsFilterProps) => (
  <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
    <Template {...templateProps} />
  </Filter.Provider>
);

export * from './schemaTypes';
